import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { ResourceMasterService } from 'src/app/pages/sa/resource-master/resource-master.service';
import * as fromSaResources from './sa-resources.selectors';
import { EMPTY, Observable, of } from 'rxjs';
import * as SaResourcesActions from './sa-resources.actions';
import { select, Store } from '@ngrx/store';
import * as Helper from '../helpers/helper.effects';
import { createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';

@Injectable()
export class SaResourceEffects {
  loadOverRideRto$ = Helper.createEffectModified(this, {
    lookupType: SaResourcesActions.loadResouceRtoOver,
    entitySelector: fromSaResources.getOverRideRto,
    service: () => this.saResourcesService.getOverRideRto(),
    callback: (response: any) => {
      return SaResourcesActions.loadResouceRtoOverSuccess({
        resRto: response.body,
      });
    },
    dummyAction: SaResourcesActions.dummyAction,
  });

  constructor(
    public actions$: Actions,
    public store: Store,
    private saResourcesService: ResourceMasterService
  ) {}
}
